import React, { useRef, useEffect } from 'react';
import { Container } from 'reactstrap';
import { getAssetUrl } from '../../services/cdn';
import SwiperCore, { Autoplay, Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import "../../styles/theme/default/components/_swiper.scss";

// Swiper modules
SwiperCore.use([Navigation, Autoplay]);

const FeaturedMC = () => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const bikes = [
  // Honda 
  { name: "HONDA ADV 160", image: getAssetUrl("koopsiklo/mc/h_adv160.jpg") },
  { name: "HONDA BEAT PREMIUM", image: getAssetUrl("koopsiklo/mc/h_beatp.jpg") },
  { name: "HONDA CLICK 125", image: getAssetUrl("koopsiklo/mc/h_click125.jpg") },
  { name: "HONDA CLICK 125 (SPECIAL EDITION)", image: getAssetUrl("koopsiklo/mc/h_click125s.jpg") },
  { name: "HONDA PCX 160 (ROADTYPE)", image: getAssetUrl("koopsiklo/mc/h_pcxrs.jpg") },
  { name: "HONDA PCX 160 (STANDARD TYPE)", image: getAssetUrl("koopsiklo/mc/h_pcxst.jpg") },
  { name: "HONDA TMX 125", image: getAssetUrl("koopsiklo/mc/h_tmx125.jpg") },
  { name: "HONDA TMX SUPREMO", image: getAssetUrl("koopsiklo/mc/h_tmxs.jpg") },
  { name: "HONDA WINNER X (ABS RACING TYPE)", image: getAssetUrl("koopsiklo/mc/h_winnerxabs.jpg") },
  { name: "HONDA WINNER X (STANDARD)", image: getAssetUrl("koopsiklo/mc/h_winnerxs.jpg") },
  { name: "HONDA CLICK 160", image: getAssetUrl("koopsiklo/mc/h_click160.jpg") },
  { name: "HONDA CRF 150", image: getAssetUrl("koopsiklo/mc/h_crf150.jpg") },
  { name: "HONDA GIORNO", image: getAssetUrl("koopsiklo/mc/h_giorno.jpg") },
  { name: "HONDA XR 150", image: getAssetUrl("koopsiklo/mc/h_xr150.jpg") },
  { name: "HONDA CLICK NEW SERIES (STANDARD)", image: getAssetUrl("koopsiklo/mc/h_clicknss.jpg") },

  // Kawasaki 
  { name: "KAWASAKI BARAKO III", image: getAssetUrl("koopsiklo/mc/k_barako3.jpg") },
  { name: "KAWASAKI CT 125", image: getAssetUrl("koopsiklo/mc/k_ct125.jpg") },

  // Suzuki 
  { name: "SUZUKI BURGMAN STREET", image: getAssetUrl("koopsiklo/mc/s_burgman.jpg") },
  { name: "SUZUKI GIXXER SF 155", image: getAssetUrl("koopsiklo/mc/s_gixxersf.jpg") },
  { name: "SUZUKI RAIDER R150 CARB", image: getAssetUrl("koopsiklo/mc/s_raider150c.jpg") },
  { name: "SUZUKI RAIDER R150 FI", image: getAssetUrl("koopsiklo/mc/s_raider150fi.jpg") },
  { name: "SUZUKI SKYDRIVE CROSSOVER", image: getAssetUrl("koopsiklo/mc/s_skydriveco.jpg") },
  { name: "SUZUKI SMASH FI (MAGS)", image: getAssetUrl("koopsiklo/mc/s_smashfi.jpg") },
  { name: "SUZUKI GIXXER NAKED 250", image: getAssetUrl("koopsiklo/mc/s_gixxern250.jpg") },
  { name: "SUZUKI ACCESS 125", image: getAssetUrl("koopsiklo/mc/s_access.jpg") },
  { name: "SUZUKI AVENIS 125", image: getAssetUrl("koopsiklo/mc/s_avenis.jpg") },
  { name: "SUZUKI V-STROM 250", image: getAssetUrl("koopsiklo/mc/s_vstorm.jpg") },
  { name: "SUZUKI RAIDER J CROSS OVER", image: getAssetUrl("koopsiklo/mc/s_raiderjcross.jpg") },
  { name: "SUZUKI SKYDRIVE SPORT", image: getAssetUrl("koopsiklo/mc/s_skydrivesport.jpg") },
  { name: "SUZUKI SMASH CARB", image: getAssetUrl("koopsiklo/mc/s_smashc.jpg") },

  // Yamaha 
  { name: "YAMAHA MIO AEROX", image: getAssetUrl("koopsiklo/mc/y_aerox.jpg") },
  { name: "YAMAHA MIO AEROX S", image: getAssetUrl("koopsiklo/mc/y_aeroxs.jpg") },
  { name: "YAMAHA MIO SPORTY", image: getAssetUrl("koopsiklo/mc/y_msporty.jpg") },
  { name: "YAMAHA NMAX", image: getAssetUrl("koopsiklo/mc/y_nmax.jpg") },
  { name: "YAMAHA SNIPER 155", image: getAssetUrl("koopsiklo/mc/y_sniper155.jpg") },
  { name: "YAMAHA GEAR S", image: getAssetUrl("koopsiklo/mc/y_gears.jpg") },
  { name: "YAMAHA GRAVIS 125", image: getAssetUrl("koopsiklo/mc/y_gravis125.jpg") },
  { name: "YAMAHA AEROX SP", image: getAssetUrl("koopsiklo/mc/y_aeroxsp.jpg") },
  { name: "YAMAHA AEROX V3 STANDARD", image: getAssetUrl("koopsiklo/mc/y_aeroxstandard.jpg") },
  { name: "YAMAHA FAZZIO", image: getAssetUrl("koopsiklo/mc/y_fazzio.jpg") },
  { name: "YAMAHA MIO 125", image: getAssetUrl("koopsiklo/mc/y_mio125.jpg") },
  { name: "YAMAHA MIO 125s", image: getAssetUrl("koopsiklo/mc/y_mio125s.jpg") },
  { name: "YAMAHA NMAX TECHMAX", image: getAssetUrl("koopsiklo/mc/y_nmaxtechmax.jpg") },
  { name: "YAMAHA PG-1", image: getAssetUrl("koopsiklo/mc/y_pg1.jpg") },
  { name: "YAMAHA SNIPER BAY 6", image: getAssetUrl("koopsiklo/mc/y_sniperbay6.jpg") },
  { name: "YAMAHA SNIPER 155r", image: getAssetUrl("koopsiklo/mc/y_sniper155r.jpg") },
  { name: "YAMAHA YTS 125", image: getAssetUrl("koopsiklo/mc/y_ytx125.jpg") },
];


  return (
    <Container className="my-0 my-5">
      <div className="featured-container">
        <h2 className="featured-title">FEATURED MOTORCYCLE</h2>
        <p className="featured-subtitle">
          Check the latest motorcycles in our store. Come and visit us.
        </p>

        <div className="swiper-button-prev custom-nav" ref={prevRef}></div>
        <div className="swiper-button-next custom-nav" ref={nextRef}></div>

        <Swiper
          spaceBetween={30}
          slidesPerView={1}
          loop={true}
          autoplay={{
            delay: 3000, // auto swipe every 3 seconds
            disableOnInteraction: true, // keep autoplay even when user interacts
          }}
          onInit={(swiper) => {
            swiper.params.navigation.prevEl = prevRef.current;
            swiper.params.navigation.nextEl = nextRef.current;
            swiper.navigation.init();
            swiper.navigation.update();
          }}
        >
          {bikes.map((bike, index) => (
            <SwiperSlide key={index}>
              <div className="bike-slide">
                <img src={bike.image} alt={bike.name} />
                {/* <h3 className="bike-name">{bike.name}</h3> */}
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </Container>
  );
};

export default FeaturedMC;
